export const formStateMachineDefinition = {
  initial: 'category',
  states: {
    category: {
      on: {
        next: 'message'
      }
    },
    message: {
      on: {
        next: 'details',
        back: 'category'
      }
    },
    details: {
      on: {
        back: 'message',
        sent: 'success',
        error: 'error'
      }
    },
    success: {},
    error: {}
  }
};
